import { Box } from '@mui/material';
import { GridRenderCellParams, useGridApiContext } from '@mui/x-data-grid-pro';
import { DatePicker } from '@mui/x-date-pickers-pro';
import { useEffect, useRef } from 'react';
import { convertToLocalDate } from '../../../utils/helpers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface CustomDateInputProps extends GridRenderCellParams<any, Date> {
  isMonthYear?: boolean;
}

export const CustomDateInput = (props: CustomDateInputProps) => {
  const { id, value, field, hasFocus, isMonthYear } = props;
  const apiRef = useGridApiContext();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (dateValue: Date | null) => {
    apiRef.current.setEditCellValue({ id, field, value: formatDate(dateValue) });
  };

  const formatDate = (dateValue: Date | null) => {
    if (!dateValue) return '';
    if (dateValue.toString() === 'Invalid Date') return '';
    const day = isMonthYear ? 15 : dateValue.getDate();

    return new Date(Date.UTC(dateValue.getFullYear(), dateValue.getMonth(), day)).toISOString();
  };

  useEffect(() => {
    if (hasFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [hasFocus]);

  return (
    <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', pr: 2 }}>
      <DatePicker
        sx={{
          width: '100%',
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              border: 'none'
            },
            '&:hover fieldset': {
              border: 'none'
            },
            '&.Mui-focused fieldset': {
              border: 'none'
            }
          }
        }}
        views={isMonthYear ? ['month', 'year'] : undefined}
        value={convertToLocalDate(value)}
        onChange={handleChange}
        format={isMonthYear ? 'MM/yyyy' : 'MM/dd/yyyy'}
        slotProps={{
          actionBar: {
            actions: isMonthYear ? [] : ['today']
          }
        }}
      />
    </Box>
  );
};
